// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"857":"c0b51cda","947":"89724540"}[chunkId] + ".chunk.css";
};